import { AsyncResult } from '@common/result/asyncResult';
import { EgiAppEntity } from '@/app/platform/platform-data/models/egi-app.entity';
import { ErrorInformation } from '@shared/models/error/error-information';
import { InjectionToken } from '@angular/core';
import { NavigationItemEntity } from '@/app/platform/platform-data/models/navigation-item.entity';
import { UserGroupEntity } from '@/app/platform/platform-data/models/user-group.entity';
import { EgiPage } from '@ervo/page-framework';

export const EGI_APP_SYNCHRONIZER = new InjectionToken<EgiAppsSynchronizer>('');

export interface EgiAppsSynchronizer {
  synchronizeApps(): AsyncResult<
    EgiAppEntity[],
    ErrorInformation | ErrorInformation<FaultyClickTroughConfiguration[]>
  >;

  synchronizeNavigationItem(
    item: NavigationItemEntity,
    groups: UserGroupEntity[]
  ): AsyncResult<NavigationItemEntity, ErrorInformation>;

  synchronizeApp(
    app: EgiAppEntity,
    groups: UserGroupEntity[]
  ): AsyncResult<EgiAppEntity, ErrorInformation>;
}

export interface FaultyClickTroughConfiguration {
  page: EgiPage;
  faultyId: string;
}
